import React from 'react';

import { SNumberList } from './styles';

import NumberItem from './NumberItem';

const NumberList = ({ listData, paddingSmall }) => (
    <SNumberList>
        {
            listData.map(itemData => (
                <NumberItem
                    itemData={ itemData }
                    key={ itemData.id }
                    paddingSmall={ paddingSmall }
                />
            ))
        }
    </SNumberList>
);

export default NumberList;
